import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {deletePodcast, getPodcasts} from "../../actions/NewsPages";
import {IMAGE_URL} from "../../path";

function PodcastsList() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [podcasts, setPodcasts] = useState<any[]>([]);

    useEffect(() => {
        getAllPodcasts();
    }, []);
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 10;


    // Pagination helpers
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = podcasts.slice(indexOfFirstPost, indexOfLastPost);
    const totalPages = Math.ceil(podcasts.length / postsPerPage);

    const handlePageChange = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    };

    const handleDelete = async (postId: number) => {
        if (window.confirm("Are you sure you want to delete this podcast?")) {
            try {
                await deletePodcast(postId);
                // After successful delete, reload the data
                getAllPodcasts();
            } catch (error) {
                console.error("Failed to delete podcast:", error);
                alert("Failed to delete the podcast. Please try again.");
            }
        }
    };

    function getAllPodcasts() {
        getPodcasts()
            .then(response => {
                setPodcasts(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch news stories:", error);
            });
    }
    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>

                <div className="content-form-button right-align">
                    <button
                        type="button"
                        className="button button-right"
                        onClick={() => navigate('/dashboard/podcasts/create', { state: { user } })}
                    >
                        Add New Podcast
                    </button>
                </div>

                {/* News Posts Table */}
                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "50%" }}>Title</th>
                            <th style={{ width: "30%" }}>Image</th>
                            <th style={{ width: "20%" }}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {currentPosts.map((post) => (
                            <tr key={post.id}>
                                <td>{post.title}</td>
                                <td>
                                    {post.image ? (
                                        <img
                                            src={IMAGE_URL + post.image}
                                            alt="Image"
                                            style={{
                                                width: "100%",
                                                maxHeight: "120px",
                                                objectFit: "cover",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    ) : (
                                        <span>No image</span>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="button small"
                                        onClick={() => navigate(`/dashboard/podcasts/${post.id}/edit`, { state: { user } })}
                                        style={{ marginRight: "10px" }}
                                    >
                                        View / Edit
                                    </button>
                                    <button
                                        className="button small danger"
                                        onClick={() =>
                                            handleDelete(post.id)}
                                        style={{ color: "black" }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
                            <button
                                key={pageNumber}
                                className={`pagination-button ${currentPage === pageNumber ? "active" : ""}`}
                                onClick={() => handlePageChange(pageNumber)}
                            >
                                {pageNumber}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PodcastsList;
